/**
 * @param {string | null | undefined} sender
 * @returns {boolean}
 */
export function isBotMessageSender(sender) {
  const s = String(sender ?? "")
    .trim()
    .toLowerCase();
  return s === "bot" || s === "ai" || s === "assistant";
}

/**
 * @param {string | null | undefined} sender
 * @returns {boolean}
 */
export function isAgentMessageSender(sender) {
  const s = String(sender ?? "")
    .trim()
    .toLowerCase();
  if (s === "agent" || s === "human_agent") return true;
  return s.includes("human") && s.includes("agent");
}
